/* Salute Pura — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var announce = function (message) {
    var live = document.getElementById('sp-a11y-live');
    if (live) live.textContent = message;
  };

  /* ------------------------------------------------------- mobile drawer */
  var MenuDrawer = {
    lastFocus: null,
    open: function () {
      var drawer = document.getElementById('MenuDrawer');
      if (!drawer) return;
      this.lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    },
    close: function () {
      var drawer = document.getElementById('MenuDrawer');
      if (!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    }
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-menu-open]');
    if (opener) {
      event.preventDefault();
      MenuDrawer.open();
      return;
    }
    if (event.target.closest('[data-menu-close]')) {
      event.preventDefault();
      MenuDrawer.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') MenuDrawer.close();
  });

  /* ------------------------------------------------ menubeelden vooraf */

  /* De beelden in mega menu en menulade staan op lazy, dus ze laden pas bij
     openen en verschijnen dan met vertraging. Na de paginaload, als de
     browser niets te doen heeft, alsnog ophalen; daarna komen ze uit de cache.
     Alleen het menu dat bij de schermbreedte hoort: mobiel de lade, desktop de mega. */
  window.addEventListener('load', function () {
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
    var menu = matchMedia('(min-width: 990px)').matches ? '[data-sp-header] .sp-nav' : '#MenuDrawer';
    idle(function () {
      document.querySelectorAll(menu + ' img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    });
  });

  /* ---------------------------------------------------- zoeken in de nav */

  /* Het formulier post gewoon naar /search als er geen JavaScript is. Met
     JavaScript halen we dezelfde sectie op die Shopify voor suggesties
     rendert, zodat prijzen door Liquid worden opgemaakt. */
  var HeaderSearch = {
    panel: null,
    input: null,
    results: null,
    controller: null,
    timer: null,
    lastTerm: '',

    init: function () {
      this.panel = document.querySelector('[data-search-panel]');
      if (!this.panel) return;
      this.input = this.panel.querySelector('[data-search-input]');
      this.results = this.panel.querySelector('[data-search-results]');
      var self = this;
      if (this.input) {
        this.input.addEventListener('input', function () { self.onInput(); });
      }
    },

    isOpen: function () {
      return !!this.panel && !this.panel.hidden;
    },

    toggles: function () {
      return document.querySelectorAll('[data-search-toggle]');
    },

    open: function () {
      if (!this.panel) return;
      this.panel.hidden = false;
      this.toggles().forEach(function (node) { node.setAttribute('aria-expanded', 'true'); });
      if (this.input) this.input.focus();
    },

    close: function () {
      if (!this.panel) return;
      this.panel.hidden = true;
      this.toggles().forEach(function (node) { node.setAttribute('aria-expanded', 'false'); });
    },

    toggle: function () {
      if (this.isOpen()) this.close(); else this.open();
    },

    onInput: function () {
      var self = this;
      var term = this.input.value.trim();

      if (this.timer) clearTimeout(this.timer);

      if (term.length < 2) {
        this.lastTerm = '';
        if (this.results) this.results.innerHTML = '';
        return;
      }
      if (term === this.lastTerm) return;

      this.timer = setTimeout(function () { self.fetch(term); }, 220);
    },

    fetch: function (term) {
      var self = this;
      var base = this.panel.getAttribute('data-search-url') || '/search/suggest';
      var section = this.panel.getAttribute('data-search-section') || 'predictive-search';
      var url = base +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=' + encodeURIComponent(section);

      if (this.controller) this.controller.abort();
      this.controller = window.AbortController ? new AbortController() : null;

      if (this.results && !this.results.innerHTML) {
        var loading = this.panel.getAttribute('data-loading-text') || '';
        this.results.innerHTML = '<p class="sp-search__status">' + loading + '</p>';
      }

      fetch(url, this.controller ? { signal: this.controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error('search failed');
          return response.text();
        })
        .then(function (html) {
          self.lastTerm = term;
          if (!self.results) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fragment = parsed.querySelector('[data-predictive-results]');
          self.results.innerHTML = fragment ? fragment.innerHTML : '';
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          // Bij een fout blijft het formulier bruikbaar: enter voert de
          // gewone zoekopdracht uit op /search.
          if (self.results) self.results.innerHTML = '';
        });
    }
  };

  HeaderSearch.init();

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-search-toggle]')) {
      event.preventDefault();
      if (event.target.closest('.sp-drawer')) {
        // Vanuit de mobiele drawer sluit het menu eerst en geeft het de focus
        // terug; daarna pas opent het veld, anders springt de focus weg.
        setTimeout(function () { HeaderSearch.open(); }, 0);
      } else {
        HeaderSearch.toggle();
      }
      return;
    }

    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      HeaderSearch.close();
      return;
    }

    // Alleen echte klikken sluiten het veld; een script-klik (hero-autoplay
    // roept tab.click() aan) mag het niet wegklappen.
    if (event.isTrusted && HeaderSearch.isOpen() && !event.target.closest('.sp-search') && !event.target.closest('.sp-header')) {
      HeaderSearch.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && HeaderSearch.isOpen()) HeaderSearch.close();
  });

  /* ------------------------------------------------------ quantity input */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;
    event.preventDefault();
    var wrapper = button.closest('.sp-qty');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var step = parseInt(button.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + step;
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------ winkeltas */

  /* Alles wat de winkeltas verandert gaat via de Ajax API en haalt daarna
     alleen de winkeltas-sectie opnieuw op. Een volledige herlaadbeurt kost
     een halve seconde en gooit de scrollpositie weg voor een regel die met
     één cijfer verandert. */
  var Cart = {
    /* Het aantal in de header komt uit /cart.js en niet uit een eigen
       teller: zo klopt het ook als er in een ander tabblad iets verandert. */
    syncCount: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (node) {
            node.textContent = cart.item_count;
          });
          document.querySelectorAll('.sp-cart-link').forEach(function (node) {
            if (cart.item_count > 0) node.setAttribute('data-has-items', '');
            else node.removeAttribute('data-has-items');
          });
          return Promise.resolve(Cart.refreshMini()).then(function () { return cart; });
        });
    },

    /* Minicart in de header: zelfde sectie-truc, fouten mogen stil blijven
       omdat de link naar de winkeltas altijd werkt. */
    refreshMini: function () {
      var mini = document.querySelector('[data-minicart]');
      if (!mini) return;
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(mini.getAttribute('data-section-id')))
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-minicart]');
          if (next) mini.innerHTML = next.innerHTML;
        })
        .catch(function () {});
    },

    /* Na toevoegen klapt de minicart even open, ook op mobiel. Een tik of klik buiten de kaart of Escape sluit hem. */
    openMini: function () {
      var wrap = document.querySelector('.sp-minicart-wrap');
      if (!wrap) return;
      var close = function (event) {
        if (event && event.type === 'click' && wrap.contains(event.target)) return;
        if (event && event.type === 'keydown' && event.key !== 'Escape') return;
        wrap.removeAttribute('data-open');
        clearTimeout(timer);
        document.removeEventListener('click', close);
        document.removeEventListener('keydown', close);
      };
      var timer = setTimeout(close, 5000);
      wrap.setAttribute('data-open', '');
      document.addEventListener('click', close);
      document.addEventListener('keydown', close);
    },

    refresh: function (root) {
      var id = root.getAttribute('data-section-id');
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
        .then(function (response) {
          if (!response.ok) throw new Error('cart section failed');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = parsed.querySelector('[data-cart-root]');
          if (!next) throw new Error('cart root missing');
          root.innerHTML = next.innerHTML;
        });
    },

    change: function (root, line, quantity) {
      root.setAttribute('data-pending', '');
      announce(root.getAttribute('data-updating-text') || '');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('change failed');
          return response.json();
        })
        .then(function () {
          return Promise.all([Cart.refresh(root), Cart.syncCount()]);
        })
        .then(function () {
          root.removeAttribute('data-pending');
          announce(root.getAttribute('data-updated-text') || '');
        })
        .catch(function () {
          // Liever een herlaadbeurt dan een winkeltas die iets anders toont
          // dan wat de server weet.
          window.location.reload();
        });
    }
  };

  /* --------------------------------------------------- cart line updates */

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;

    var root = input.closest('[data-cart-root]');
    var line = parseInt(input.getAttribute('data-cart-line'), 10);

    if (!root || !line || !window.fetch) {
      var form = input.closest('form');
      if (form) form.submit();
      return;
    }

    // De plus- en minknop vuren per klik. Even wachten, anders staan er vier
    // verzoeken onderweg voor één bedoeling.
    if (input.mpQtyTimer) clearTimeout(input.mpQtyTimer);
    input.mpQtyTimer = setTimeout(function () {
      Cart.change(root, line, parseInt(input.value, 10) || 0);
    }, 300);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;

    var root = remove.closest('[data-cart-root]');
    var line = parseInt(remove.getAttribute('data-cart-remove'), 10);
    if (!root || !line || !window.fetch) return; // de href doet dan het werk

    event.preventDefault();
    Cart.change(root, line, 0);
  });

  /* ---------------------------------------------------- collection sorting */

  /* Sorteren ververst alleen het raster. Het adres in de balk gaat mee zodat
     de sortering deelbaar blijft en een herlaadbeurt hetzelfde toont. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sort-select]');
    if (!select) return;

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');

    var root = document.querySelector('[data-collection-root]');
    if (!root || !window.fetch) {
      window.location.href = url.toString();
      return;
    }

    var sectionUrl = new URL(url.toString());
    sectionUrl.searchParams.set('section_id', root.getAttribute('data-section-id'));

    root.setAttribute('data-pending', '');

    fetch(sectionUrl.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('sort failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-collection-root]');
        if (!next) throw new Error('collection root missing');

        root.innerHTML = next.innerHTML;
        root.removeAttribute('data-pending');
        window.history.replaceState({}, '', url.toString());

        // Het keuzemenu is zojuist vervangen; de focus zat erop en moet mee.
        var fresh = root.querySelector('[data-sort-select]');
        if (fresh) fresh.focus();
      })
      .catch(function () {
        window.location.href = url.toString();
      });
  });

  /* ------------------------------------------------- collection load more */

  /* "Meer laden" haalt de volgende pagina van de sectie op en zet de kaarten
     onder het raster. Zonder fetch werkt de knop als gewone link. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more]');
    if (!button || !window.fetch) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var root = button.closest('[data-collection-root]');
    var grid = root && root.querySelector('[data-coll-grid]');
    if (!grid) {
      window.location.href = button.href;
      return;
    }

    var url = new URL(button.href, window.location.href);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));
    button.setAttribute('aria-busy', 'true');

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('load more failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = parsed.querySelector('[data-coll-grid]');
        if (!nextGrid) throw new Error('grid missing');

        var first = nextGrid.firstElementChild;
        while (nextGrid.firstChild) grid.appendChild(nextGrid.firstChild);

        var nextButton = parsed.querySelector('[data-load-more]');
        if (nextButton) {
          button.href = nextButton.getAttribute('href');
          button.removeAttribute('aria-busy');
        } else {
          button.parentNode.remove();
        }

        // Focus naar de eerste nieuwe kaart, zodat toetsenbordgebruikers verder kunnen.
        var link = first && first.querySelector('a, button');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = button.href;
      });
  });

  /* -------------------------------------------------------- product media */
  // De grote foto is een scroll-strook (swipen op touch is native); thumbnails
  // en de strook houden elkaar bij.
  function markThumb(gallery, id) {
    gallery.querySelectorAll('[data-media-thumb]').forEach(function (node) {
      var active = node.getAttribute('data-media-id') === id;
      node.setAttribute('aria-current', active ? 'true' : 'false');
      if (!active) return;
      // Alleen horizontaal binnen de rij schuiven, nooit de pagina.
      var row = node.parentElement;
      var rowBox = row.getBoundingClientRect();
      var box = node.getBoundingClientRect();
      row.scrollBy({ left: box.left - rowBox.left - (rowBox.width - box.width) / 2, behavior: 'smooth' });
    });
  }

  function showSlide(gallery, id, smooth) {
    var track = gallery.querySelector('[data-media-track]');
    var slide = track && track.querySelector('[data-media-id="' + id + '"]');
    if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-media-thumb]');
    if (!thumb) return;
    event.preventDefault();
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var id = thumb.getAttribute('data-media-id');
    showSlide(gallery, id, true);
    markThumb(gallery, id);
  });

  var slideTimer;
  document.addEventListener('scroll', function (event) {
    var track = event.target.closest && event.target.closest('[data-media-track]');
    if (!track || track.classList.contains('is-dragging')) return;
    clearTimeout(slideTimer);
    slideTimer = setTimeout(function () {
      var slide = track.children[Math.round(track.scrollLeft / track.clientWidth)];
      var gallery = track.closest('[data-product-gallery]');
      var id = slide && slide.getAttribute('data-media-id');
      if (!gallery || !id) return;
      var thumb = gallery.querySelector('[data-media-thumb][aria-current="true"]');
      if (!thumb || thumb.getAttribute('data-media-id') !== id) markThumb(gallery, id);
    }, 120);
  }, true);

  // Start op de uitgelichte foto (variantfoto kan middenin de strook staan).
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumb = gallery.querySelector('[data-media-thumb][aria-current="true"]');
    if (thumb) showSlide(gallery, thumb.getAttribute('data-media-id'), false);
  });

  // Slepen met de muis door strook en thumbnail-rij; touch scrollt al native.
  var drag = null;
  var dragged = false;
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var el = event.target.closest('[data-drag-scroll]');
    drag = el ? { el: el, x: event.clientX, left: el.scrollLeft, moved: false } : null;
  });
  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    var dx = event.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 5) return;
    if (!drag.moved) {
      drag.moved = true;
      drag.el.classList.add('is-dragging');
    }
    drag.el.scrollLeft = drag.left - dx;
  });
  document.addEventListener('pointerup', function (event) {
    if (!drag) return;
    var el = drag.el;
    var forward = event.clientX < drag.x;
    var moved = drag.moved;
    drag = null;
    if (!moved) return;
    // Naar het volgende of vorige beeld in de sleeprichting.
    var pos = el.scrollLeft;
    var target = forward ? el.scrollWidth : 0;
    Array.prototype.forEach.call(el.children, function (child) {
      var left = child.offsetLeft;
      if (forward ? left >= pos && left < target : left <= pos && left > target) target = left;
    });
    el.classList.remove('is-dragging');
    el.scrollTo({ left: target, behavior: 'smooth' });
    // De klik die op het loslaten volgt, mag geen thumbnail kiezen.
    dragged = true;
    setTimeout(function () { dragged = false; }, 0);
  });
  document.addEventListener('click', function (event) {
    if (dragged) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest('[data-drag-scroll]')) event.preventDefault();
  });

  /* --------------------------------------------------------- variant picker */
  function VariantPicker(root) {
    this.root = root;
    this.variants = [];
    var data = root.querySelector('[data-variant-json]');
    if (data) {
      try { this.variants = JSON.parse(data.textContent); } catch (error) { this.variants = []; }
    }
    this.idInput = root.querySelector('[data-variant-id]');
    this.priceTarget = root.querySelector('[data-price]');
    this.submit = root.querySelector('[data-add-button]');
    this.skuTarget = root.querySelector('[data-sku]');
    this.root.addEventListener('change', this.onChange.bind(this));
  }

  VariantPicker.prototype.selectedOptions = function () {
    return Array.prototype.map.call(
      this.root.querySelectorAll('[data-option-index]'),
      function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      }
    );
  };

  VariantPicker.prototype.match = function () {
    var selected = this.selectedOptions();
    return this.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selected[index];
      });
    });
  };

  VariantPicker.prototype.onChange = function (event) {
    /* Alleen optievelden kiezen een variant. Aantal of bestelwijze in
       hetzelfde formulier mogen de koopknop niet omzetten. */
    if (!event.target.closest('[data-option-index]')) return;
    var variant = this.match();

    if (this.idInput) this.idInput.value = variant ? variant.id : '';

    if (variant && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (this.priceTarget && variant) {
      var onSale = variant.compare_at_price > variant.price;
      var html = onSale
        ? '<s>' + variant.compare_at_price_formatted + '</s>' +
          '<span class="sp-price__sale">' + variant.price_formatted + '</span>'
        : variant.price_formatted;
      this.priceTarget.innerHTML = html;
    }

    if (this.skuTarget && variant) this.skuTarget.textContent = variant.sku || '';

    // Variant met eigen foto: dezelfde weg als een klik op die thumbnail.
    if (variant && variant.media_id) {
      var scope = this.root.closest('.shopify-section') || document;
      var thumb = scope.querySelector('[data-media-thumb][data-media-id="' + variant.media_id + '"]');
      if (thumb) thumb.click();
    }

    if (this.submit) {
      var available = variant && variant.available;
      var label = this.submit.getAttribute(
        !variant ? 'data-unavailable-text' : available ? 'data-default-text' : 'data-sold-out-text'
      );
      this.submit.disabled = !available;

      // De koopknop is een balk met de actie links en de prijs rechts, dus
      // alleen het labelveld overschrijven en niet de hele knop.
      var labelTarget = this.submit.querySelector('[data-add-label]');
      if (labelTarget) {
        labelTarget.textContent = label;
      } else {
        this.submit.textContent = label;
      }

      var priceTarget = this.submit.querySelector('[data-add-price]');
      if (priceTarget) priceTarget.textContent = variant ? variant.price_formatted : '';
    }
  };

  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    new VariantPicker(root);
  });

  /* ------------------------------------------------- variant op productkaart */

  /* De radio zelf bepaalt wat de koopknop toevoegt; hier alleen foto, prijs
     en link bijwerken zodat de kaart laat zien wat er gekozen is. */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-card-variant]');
    if (!input) return;
    var card = input.closest('.sp-card');
    var img = card.querySelector('.sp-card__media > img');
    var price = card.querySelector('[data-card-price]');
    var link = card.querySelector('.sp-card__title a');
    if (img && input.dataset.src) {
      img.srcset = input.dataset.srcset;
      img.src = input.dataset.src;
    }
    if (price) price.innerHTML = input.dataset.price;
    if (link) link.href = input.dataset.url;
  });

  /* ------------------------------------------------------ add to cart form */
  /* Het stuk wordt toegevoegd zonder de pagina te verlaten. Op de
     productpagina komt de bevestiging ook onder de knop, op de plek waar de
     handeling gebeurde. Daarna klapt de minicart open, met de stand tot
     gratis verzending. Zonder fetch post het formulier gewoon naar /cart/add. */
  /* --------------------------------------------------------------- dialogs */
  /* Sluitknop en klik op de achtergrond (de dialog zelf) sluiten. */
  document.addEventListener('click', function (event) {
    var dialog = event.target.closest('dialog.sp-dialog');
    if (!dialog) return;
    if (event.target === dialog || event.target.closest('[data-dialog-close]')) dialog.close();
  });

  /* -------------------------------------------- snelkoop vanaf productkaart */
  /* Kaart met iets te kiezen (data-quick): toon de <template> uit
     snippets/quick-buy.liquid in #SpQuick. Zonder dialog-support voegt de
     kaart gewoon direct toe. */
  var QuickBuy = {
    open: function (form) {
      var dialog = document.getElementById('SpQuick');
      var body = dialog && dialog.querySelector('[data-quick-body]');
      var tpl = form.querySelector('template[data-quick-tpl]');
      if (!body || !tpl || !dialog.showModal) {
        form.removeAttribute('data-quick');
        form.requestSubmit();
        return;
      }
      body.replaceChildren(tpl.content.cloneNode(true));
      // De variant die op de kaart gekozen was, ook in het venster kiezen.
      var id = new FormData(form).get('id');
      var pick = id && body.querySelector('input[name="id"][value="' + id + '"]');
      if (pick && !pick.disabled) pick.checked = true;
      QuickBuy.sync(body);
      dialog.showModal();
    },
    /* Prijzen per bestelwijze, foto, koopknop en bundel volgen de variant. */
    sync: function (root) {
      var variant = root.querySelector('input[name="id"]:checked');
      var plan = root.querySelector('input[name="selling_plan"]:checked');
      if (variant) {
        var prices = JSON.parse(variant.getAttribute('data-plans') || '{}');
        root.querySelectorAll('[data-plan-price]').forEach(function (el) {
          var price = prices[el.getAttribute('data-plan-price')];
          if (price) el.textContent = price;
        });
        var img = root.querySelector('.sp-quick__img');
        if (img && variant.dataset.img) { img.removeAttribute('srcset'); img.src = variant.dataset.img; }
        var bundle = root.querySelector('[data-bundle-id]');
        var pair = bundle && JSON.parse(bundle.getAttribute('data-map') || '{}')[variant.value];
        if (pair) {
          bundle.value = pair[0];
          root.querySelector('[data-bundle-price]').textContent = pair[1];
        }
      }
      var target = root.querySelector('[data-quick-price]');
      var source = root.querySelector('[data-plan-price="' + (plan ? plan.value : '') + '"]');
      if (target && source) target.textContent = source.textContent;
    }
  };
  document.addEventListener('change', function (event) {
    var root = event.target.closest('[data-quick-root]');
    if (root) QuickBuy.sync(root);
  });

  /* ------------------------------------------ abonnement-vraag op productpagina */
  /* Eenmalig gekozen en het product heeft een abonnement: eerst één keer
     vragen of het een abonnement mag worden. Elk antwoord verstuurt daarna. */
  var askAbo = function (form) {
    if (form.hasAttribute('data-nudged')) return false;
    // getAttribute: form.id geeft het <input name="id"> (variant) terug.
    var dialog = document.querySelector('[data-abo-nudge="' + form.getAttribute('id') + '"]');
    var plan = form.querySelector('input[name="selling_plan"]:checked');
    if (!dialog || !dialog.showModal || !plan || plan.value !== '') return false;
    dialog.showModal();
    dialog.onclick = function (event) {
      var choice = event.target.closest('[data-nudge-choice]');
      if (!choice) return;
      if (choice.getAttribute('data-nudge-choice') === 'abo') {
        var abo = form.querySelector('input[name="selling_plan"][value="' + dialog.getAttribute('data-plan') + '"]');
        if (abo) {
          abo.checked = true;
          abo.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      form.setAttribute('data-nudged', '');
      dialog.close();
      form.requestSubmit();
    };
    return true;
  };

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form.sp-product-form');
    if (!form) return;
    if (form.hasAttribute('data-quick')) {
      event.preventDefault();
      QuickBuy.open(form);
      return;
    }
    if (askAbo(form)) {
      event.preventDefault();
      return;
    }
    var button = form.querySelector('[data-add-button]');
    var feedback = form.querySelector('[data-add-feedback]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      announce(button.getAttribute('data-adding-text') || '');
    }
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    var message = feedback && feedback.querySelector('[data-add-message] span');
    var settle = function (text, failed) {
      announce(text);
      if (!feedback) return;
      feedback.classList.toggle('sp-added--error', !!failed);
      if (message) message.textContent = text;
      feedback.hidden = false;
    };
    if (feedback) feedback.hidden = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          // Shopify zet de reden in description, bijvoorbeeld als er meer
          // besteld wordt dan er op voorraad ligt. Die tekst is bruikbaarder
          // dan onze eigen algemene melding.
          if (!response.ok) throw new Error(data.description || '');
          return data;
        });
      })
      .then(function () { return Cart.syncCount(); })
      .then(function () {
        settle((feedback || button || form).getAttribute('data-success-text') || '', false);
        var dialog = form.closest('dialog');
        if (dialog) dialog.close();
        Cart.openMini();
      })
      .catch(function (error) {
        var reason = (error && error.message) || '';
        var text = reason || (feedback || button || form).getAttribute('data-error-text') || '';
        settle(text, true);
        // Op een kaart toont de knop de melding even zelf.
        if (!feedback && button) {
          var label = button.textContent;
          button.textContent = text;
          setTimeout(function () { button.textContent = label; }, 3000);
        }
      })
      .then(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });

  /* ------------------------------------------------------ header-materiaal */

  /* De haarlijn onder de header verschijnt pas als er inhoud onderdoor
     schuift. Bovenaan de pagina hoort de balk bij het vel, niet erop. */
  var header = document.querySelector('.sp-header');
  if (header) {
    var pending = false;
    var syncHeader = function () {
      pending = false;
      if (window.scrollY > 4) header.setAttribute('data-scrolled', '');
      else header.removeAttribute('data-scrolled');
    };
    window.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(syncHeader);
    }, { passive: true });
    syncHeader();
  }

  /* ---------------------------------------------------- aankondigingsbalk */

  /* De balk is een rij hoog en wisselt van boodschap. De eerste staat al
     actief in de HTML, dus zonder JavaScript blijft die gewoon staan. */
  var uspTimer = null;
  var rotateUsp = function () {
    var bar = document.querySelector('[data-usp-rotator]');
    if (uspTimer) { clearInterval(uspTimer); uspTimer = null; }
    if (!bar) return;
    var items = bar.querySelectorAll('.sp-usp__item');
    if (items.length < 2) return;
    var index = 0;
    uspTimer = setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, 5000);
  };
  rotateUsp();

  /* In de theme-editor wordt de sectie opnieuw opgebouwd; dan hangt de
     lopende teller aan knopen die niet meer in de pagina staan. */
  document.addEventListener('shopify:section:load', rotateUsp);
  document.addEventListener('shopify:section:unload', rotateUsp);

  /* ------------------------------------------------------------------ tabs */

  /* Een rij knoppen met role=tab en panelen met role=tabpanel. De markup
     zet hidden op de niet-actieve panelen; een klik wisselt ze. */
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    var root = tab.closest('[data-tabs]');
    if (!list || !root) return;
    event.preventDefault();
    list.querySelectorAll('[role="tab"]').forEach(function (node) {
      var active = node === tab;
      node.setAttribute('aria-selected', active ? 'true' : 'false');
      node.tabIndex = active ? 0 : -1;
      var panel = document.getElementById(node.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
  });

  /* Pijltoetsen tussen tabs, zoals het tabpatroon van WAI-ARIA. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    var tab = event.target.closest('[role="tab"]');
    var list = tab && tab.closest('[role="tablist"]');
    if (!list || !tab.closest('[data-tabs]')) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    event.preventDefault();
    next.focus();
    next.click();
  });

  /* ------------------------------------------------------------ carrousel */

  /* [data-carousel]: een spoor met scroll-snap ([data-carousel-track]),
     optioneel pijlen ([data-carousel-prev|next]) en puntjes
     ([data-carousel-dots]). Vegen en scrollen doet de browser zelf; hier
     alleen de knoppen en welk puntje actief is. Aan het eind springt de
     volgende-knop terug naar het begin. */
  var carouselTrack = function (node) {
    var root = node.closest('[data-carousel]');
    return root && root.querySelector('[data-carousel-track]');
  };
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-carousel-prev], [data-carousel-next], [data-carousel-dots] > button');
    var track = button && carouselTrack(button);
    if (!track) return;
    var width = track.clientWidth;
    var max = track.scrollWidth - width;
    var to;
    if (button.parentNode.hasAttribute('data-carousel-dots')) {
      to = Array.prototype.indexOf.call(button.parentNode.children, button) * width;
    } else {
      to = track.scrollLeft + (button.hasAttribute('data-carousel-next') ? width : -width);
      if (to > max + 1) to = 0;
      else if (to < -1) to = max;
    }
    track.scrollTo({ left: to, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track.matches || !track.matches('[data-carousel-track]')) return;
    var dots = track.closest('[data-carousel]').querySelector('[data-carousel-dots]');
    if (!dots) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      dot.toggleAttribute('data-active', i === index);
    });
  }, true);

  /* Safari op iOS past :active alleen toe wanneer er ergens een
     aanraakluisteraar staat. Zonder deze lege luisteraar blijft de
     ingedrukte staat op de telefoon uit. */
  document.addEventListener('touchstart', function () {}, { passive: true });
})();

